<script lang="ts">
  import { type Link } from "$lib/gql/cmsgen/codegen";

  export let link: Link;
</script>

{#if link?.href}
  <a class="hero-media-link block" href={link.href}>
    <slot />
  </a>
{:else}
  <slot />
{/if}
